module.exports = __webpack_public_path__ + "img/copperheadlogo-min-white.a179a3aa.svg";